export default __webpack_public_path__ + "static/media/rotate_90_degrees_ccw.565c8863.svg";